export const dayOfYear = (timestamp: number): string => {
    const date = new Date(timestamp * 1000);
    return `${date.getMonth()}-${date.getDate()}-${date.getFullYear()}`;
};
